export default {
  filters: {
    join(array) {
      return array.join(", ");
    }
  }
};
